import React, { useEffect } from 'react';
import Footer from '../../../Components/Ui-elements/Footer';
import Header from '../../../Components/Ui-elements/Header';
import HeadSection from '../../../Components/Ui-elements/HeadSection/HeadSection';
import { Shell } from '../../../Components/Ui-elements/StyledComponents/StyledComponents';

const TermsPage: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    return <div className='IR_termsPage'>
        <Header scroll={true} />
        <div className='headSectionWrapper'>
            <HeadSection
                theme='greenAndPurple'
                title={'Terms'}
                question={'Terms and conditions of use'}
                description="These terms and conditions apply between you, the user of this website including any subdomains, unless expressly excluded by their own terms and conditions, and Live Market Data, the owner and operator of this website."/>
        </div>
        <Shell style={{'paddingTop': '40px'}}>
            <div className='pageWrapper'>
                <div className='disclaimer'>
                    <p>
                        Please read these terms and conditions carefully, as they affect your legal rights. Your agreement to comply with and be bound by these terms and conditions is deemed to occur upon your first use of the website. If you do not agree to be bound by these terms and conditions, you should stop using the Website immediately.
                    </p>
                    <p>
                        In these terms and conditions, user or users means any third party that accesses the website and is not either
                        (i) employed by Live Market Data and acting in the course of their employment or
                        (ii) engaged as a consultant or otherwise providing services to Live Market Data and accessing the website in connection with the provision of such services.
                    </p>
                    <p>
                        You must be at least 18 years of age to use this website. By using the website and agreeing to these terms and conditions, you represent and warrant that you are at least 18 years of age.
                    </p>
                </div>

                {/* Intellectual property and acceptable use*/}
                <div className='section'>
                    <h3>Intellectual property and acceptable use</h3>
                    <ol className='list'>
                        <li className='listItem'>
                            All content included on the website, unless uploaded by users, is the property of Live Market Data, our affiliates or other relevant third parties. 
                            In these terms and conditions, content means any text, graphics, images, audio, video, software, data compilations, page layout, 
                            underlying code and software and any other form of information capable of being stored in a computer that appears on or forms part of this website, 
                            including any such content uploaded by Users. By continuing to use the website you acknowledge that such content is protected by copyright, trademarks, database rights, 
                            and other intellectual property rights. Nothing on this site shall be construed as granting, by implication, estoppel, or otherwise, any license or right to use any trademark, 
                            logo or service mark displayed on the site without the owner’s prior written permission.
                        </li>
                        <li className='listItem'>
                            You may, for your own personal, non-commercial use only, do the following:
                            <ol>
                                <li>Retrieve, display and view the content on a computer screen.</li>
                                <li>Print one copy of the content.</li>
                            </ol>
                        </li>
                        <li className='listItem'>
                            You must not otherwise reproduce, modify, copy, distribute or use for commercial purposes any content without the written permission of Live Market Data.
                        </li>
                    </ol>
                </div>

                {/* Prohibited use */}
                <div className='section'>
                    <h3>Prohibited use</h3>
                    <ol className='list'>
                        <li className='listItem'>
                            You may not use the website for any of the following purposes:
                            <ol>
                                <li>In any way which causes, or may cause, damage to the website or interferes with any other person’s use or enjoyment of the website.</li>
                                <li>In any way which is harmful, unlawful, illegal, abusive, harassing, threatening or otherwise objectionable or in breach of any applicable law, regulation, governmental order.</li>
                                <li>Making, transmitting or storing electronic copies of Content protected by copyright without the permission of the owner.</li>
                            </ol>
                        </li>
                    </ol>
                </div>

                {/* Registration */}
                <div className='section'>
                    <h3>Registration</h3>
                    <ol className='list'>
                        <li className='listItem'>
                            You must ensure that the details provided by you on registration or at any time are correct and complete.
                        </li>
                        <li className='listItem'>
                            You must inform us immediately of any changes to the information that you provide when registering by updating your personal details to ensure we can communicate with you effectively.
                        </li>
                        <li className='listItem'>
                            We may suspend or cancel your registration with immediate effect for any reasonable purposes or if you breach these terms and conditions.
                        </li>
                        <li className='listItem'>
                            You may cancel your registration at any time by informing us in writing to the address at the end of these terms and conditions. If you do so, you must immediately stop using the Website. Cancellation or suspension of your registration does not affect any statutory rights.
                        </li>
                    </ol>
                </div>

                {/* Links to other websites */}
                <div className='section'>
                    <h3>Links to other websites</h3>
                    <ol className='list'>
                        <li className='listItem'>
                            This Website may contain links to other sites. Unless expressly stated, these sites are not under the control of Live Market Data or that of our affiliates.
                        </li>
                        <li className='listItem'>
                            We assume no responsibility for the content of such websites and disclaim liability for any and all forms of loss or damage arising out of the use of them.
                        </li>
                        <li className='listItem'>
                            The inclusion of a link to another site on this website does not imply any endorsement of the sites themselves or of those in control of them.
                        </li>
                    </ol>
                </div>

                {/* Privacy policy and cookies policy */}
                <div className='section'>
                    <h3>Privacy policy and cookies policy</h3>
                    <ol className='list'>
                        <li className='listItem'>
                            Use of the Website is also governed by our privacy policy, which is incorporated into these terms and conditions by this reference
                        </li>
                    </ol>
                </div>

                {/* Availability of the website and disclaimers */}
                <div className='section'>
                    <h3>Availability of the website and disclaimers</h3>
                    <ol className='list'>
                        <li className='listItem'>
                            Any online facilities, tools, services or information that Live Market Data makes available through the website (the service) is provided “as is” and on an “as available” basis. 
                            We give no warranty that the Service will be free of defects and/or faults. 
                            To the maximum extent permitted by the law, we provide no warranties (express or implied) of fitness for a particular purpose, accuracy of information, 
                            compatibility and satisfactory quality. Live Market Data is under no obligation to update information on the website.
                        </li>
                        <li className='listItem'>
                            Whilst Live Market Data uses reasonable endeavours to ensure that the website is secure and free of errors, viruses, and other malware, 
                            we give no warranty or guaranty in that regard and all Users take responsibility for their own security, that of their personal details and their computers.
                        </li>
                        <li className='listItem'>
                            Live Market Data accepts no liability for any disruption or none availability of the website.
                        </li>
                        <li className='listItem'>
                            Live Market Data reserves the right to alter, suspend or discontinue any part (or the whole of) the website including, but not limited to, any products and/or services available. 
                            These terms and conditions shall continue to apply to any modified version of the website unless it is expressly stated otherwise.
                        </li>
                    </ol>
                </div>

                {/* Limitation of liability*/}
                <div className='section'>
                    <h3>Limitation of liability</h3>
                    <ol className='list'>
                        <li className='listItem'>
                            Nothing in these terms and conditions will:
                            <ol>
                                <li>Limit or exclude our or your liability for death or personal injury resulting from our or your negligence, as applicable.</li>
                                <li>Limit or exclude our or your liability for fraud or fraudulent misrepresentation.</li>
                                <li>Limit or exclude any of our or your liabilities in any way that is not permitted under applicable law.</li>
                            </ol>
                        </li>
                        <li className='listItem'>
                            We will not be liable to you in respect of any losses arising out of events beyond our reasonable control.
                        </li>
                        <li className='listItem'>
                            To the maximum extent permitted by law, Live Market Data accepts no liability for any of the following:
                            <ol>
                                <li>Any business losses, such as loss of profits, income, revenue, anticipated savings, business, contracts, goodwill or commercial opportunities.</li>
                                <li>Loss or corruption of any data, database or software.</li>
                                <li>Any special, indirect or consequential loss or damage.</li>
                            </ol>
                        </li>
                    </ol>
                </div>

                {/* General */}
                <div className='section'>
                    <h3>General</h3>
                    <ol className='list'>
                        <li className='listItem'>
                            You may not transfer any of your rights under these terms and conditions to any other person. 
                            We may transfer our rights under these terms and conditions where we reasonably believe your rights will not be affected.
                        </li>
                        <li className='listItem'>
                            These terms and conditions may be varied by us from time to time. 
                            Such revised terms will apply to the website from the date of publication. Users should check the terms and conditions regularly to ensure familiarity with the then current version.
                        </li>
                        <li className='listItem'>
                            These terms and conditions together with the Privacy Policy and Cookies Policy contain the whole agreement between the parties relating to its 
                            subject matter and supersede all prior discussions, arrangements or agreements that might have taken place in relation to the terms and conditions.
                        </li>
                        <li className='listItem'>
                            The Contracts (Rights of Third Parties) Act 1999 shall not apply to these terms and conditions and no third party will have any right to enforce 
                            or rely on any provision of these terms and conditions.
                        </li>
                        <li className='listItem'>
                            If any court or competent authority finds that any provision of these terms and conditions (or part of any provision) is invalid, illegal or unenforceable, 
                            that provision or part-provision will, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of these terms and conditions will not be affected.
                        </li>
                        <li className='listItem'>
                            Unless otherwise agreed, no delay, act or omission by a party in exercising any right or remedy will be deemed a waiver of that, or any other, right or remedy.
                        </li>
                        <li className='listItem'>
                            This Agreement shall be governed by and interpreted according to the law of 
                            Iceland and all disputes arising under the Agreement (including non-contractual disputes or claims) shall be subject to the exclusive jurisdiction of Iceland and Icelandic courts.
                        </li>
                    </ol>
                </div>


                {/* Live Market Data details */}
                <div className='section'>
                    <h3>Live Market Data details</h3>
                    <ol className='list'>
                        <li className='listItem'>
                            Live Market Data operates the website www.livemarketdata.com and is owned by Kóði ehf. whose registered address is Skógarhlíð 12, 105 Reykjavík. 
                        </li>
                    </ol>
                </div>
            </div>
        </Shell>
        <Footer />


    </div>

}

export default TermsPage;